import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ello': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM391.8 293.2c2.5-7.4-2.5-15.7-9.9-17.4-7.4-2.5-15.7 2.5-17.4 9.9-14 52.9-62 90.1-116.6 90.1s-102.5-37.2-116.6-90.1c-1.7-7.4-9.9-11.6-17.4-9.9-7.4 1.7-11.6 9.9-9.9 17.4 16.5 65.3 76 111.6 143.8 111.6s127.3-46.3 143.8-111.6z'
      }
    ]
  }
})
